import { AppRoleDims, AppRoleKey } from '@nk/data-entities-lib';

export function hasAllRequiredRoles(flags: AppRoleDims['flags'], requiredRoles: AppRoleKey[]): boolean {
  if (flags && Array.isArray(requiredRoles)) {
    return requiredRoles.every((i) => flags[i]);
  } else {
    return false;
  }
}
